import PlusSolidIcon from '@simplywallst/ui-core/icons/PlusSolid';
import { Button } from '@simplywallst/ui-core';
import { Heading } from '@simplywallst/ui-core/next';
import {
  ManualPortfolioProvider,
  useManualPortfolioContext,
  useManualPortfolioTracking,
} from '@/features/portfolio/components/PortfolioManual';

// Extracted component to avoid ManualPortfolioProvider context issue
const AddButton = () => {
  const { trackManualPortfolioEvent } = useManualPortfolioTracking();
  const { createPortfolio } = useManualPortfolioContext();

  return (
    <Button
      styleType="louderLarge"
      alignIcon="left"
      onClick={() => {
        trackManualPortfolioEvent({
          modifier: 'create-portfolio',
          action: 'click',
        });
        createPortfolio();
      }}
      className="w-fit"
    >
      Add my portfolio
      <PlusSolidIcon />
    </Button>
  );
};

export const NewManualPortfolio = () => {
  return (
    <div
      className="grid gap-x2 sm:gap-x3 content-between"
      data-cy-id="portfolio-manual-creation"
    >
      <div className="grid gap-x1_25">
        <Heading as="h2">Track your holdings manually</Heading>
        <div className="text-xs text-softer text-pretty max-w-[45ch]">
          Add your holdings information such as average prices and number of
          shares. Support for transactions will be available soon.
        </div>
      </div>
      <ManualPortfolioProvider>
        <AddButton />
      </ManualPortfolioProvider>
    </div>
  );
};
